export function fmtDateRange(a: number, b: number){
  const da = new Date(a), db = new Date(b);
  const opts: Intl.DateTimeFormatOptions = {hour:'2-digit', minute:'2-digit'};
  const day = da.toLocaleDateString('en-GB',{day:'2-digit',month:'short'});
  return `${day} · ${da.toLocaleTimeString('en-GB',opts)} → ${db.toLocaleTimeString('en-GB',opts)}`;
}
export function fmtRelative(epoch: number){
  const s = Math.max(0, Math.round((Date.now() - epoch)/1000));
  if(s < 60) return `${s}s ago`;
  if(s < 3600) return `${Math.round(s/60)}m ago`;
  if(s < 86400) return `${Math.round(s/3600)}h ago`;
  return `${Math.round(s/86400)}d ago`;
}
export function sparkPath(coords: number[][]){
  if(!coords.length) return '';
  let minX=Infinity,maxX=-Infinity,minY=Infinity,maxY=-Infinity;
  coords.forEach(([y,x])=>{ if(x<minX)minX=x; if(x>maxX)maxX=x; if(y<minY)minY=y; if(y>maxY)maxY=y; });
  const W=56,H=30,pad=2;
  const sx = (v: number) => pad + ((v-minX)/((maxX-minX)||1))*(W-pad*2);
  const sy = (v: number) => H-pad - ((v-minY)/((maxY-minY)||1))*(H-pad*2);
  return 'M' + coords.map(([y,x])=>`${sx(x).toFixed(1)},${sy(y).toFixed(1)}`).join(' L');
}
export function relTime(ms: number): string {
  const d = Math.max(0, Date.now() - ms);
  if(d < 60_000) return `${Math.floor(d / 1000)}s ago`;
  if(d < 3_600_000) return `${Math.floor(d / 60_000)}m ago`;
  if(d < 86_400_000) return `${Math.floor(d / 3_600_000)}h ago`;
  return `${Math.floor(d / 86_400_000)}d ago`;
}
export function fmtReplayClock(t: number){
  return new Date(t).toLocaleTimeString('en-GB', { hour:'2-digit', minute:'2-digit', second:'2-digit' });
}
